import { create } from "zustand";
import socket from "../Utils/socketClient";

export const useAuthStore = create<any>((set) => ({
  teamDetailsTrigger: false,
  selectedPlayerData: null,
  liveBidData: null,
  liveTeamId: null,

  triggerTeamDetailsUpdate: () => {
    const now = Date.now();
    socket.emit("teamDetailsTrigger", now);
    set({ teamDetailsTrigger: now });
  },

  setSelectedPlayerData: (playerData: any) => {
    socket.emit("selectedPlayerData", playerData);
    set({ selectedPlayerData: playerData });
  },

  clearSelectedPlayerData: () => {
    socket.emit("clearSelectedPlayerData");
    set({ selectedPlayerData: null });
  },

  sendLiveBidUpdate: (data: any) => {
    socket.emit("livePlayerBidUpdate", data);
    set({ liveBidData: data });
  },

  clearLiveBidData: () => {
    socket.emit("clearLiveBidData");
    set({ liveBidData: null });
  },

  // squad list
  sendLiveTeamId: (id: string) => {
    socket.emit("liveTeamDetails", id);
    set({ liveTeamId: id });
  },
  
  clearLiveTeamId: () => {
    set({ liveTeamId: null });
  },
}));
